// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'

// Controller
import layersCtrl from 'hfty-ctrl-layers'

// Exports
export default createReducer(initialState, {
  ...layersCtrl.reducers,
})
